import React from 'react';
import { Typography, Grid, TextField, Box } from '@material-ui/core';
import { DatePickerInput } from '../../../../../components/app/childrens/ui/DatepickerInput';
import { useFormsContext } from 'pages/forms/context/FormsProvider';
import { useStyles } from './styles';

export const Fields = () => {
  const { handleDtInicVigChange, dtInicVig, handleDtFimVigChange, dtFimVig, handleSearch, search } = useFormsContext();
  const classes = useStyles();

  return (
    <>
      <Box className={classes.field}>
        <Typography className={classes.title}>ID / Nome do Formulário</Typography>
        <TextField label="Pesquisar" variant="outlined" value={search} onChange={handleSearch} />
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.title}>Data</Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <DatePickerInput
              label="Início Vigência"
              handleChange={handleDtInicVigChange}
              modalTitle="Data Início Vigência"
              value={dtInicVig}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickerInput
              label="Fim Vigência"
              handleChange={handleDtFimVigChange}
              modalTitle="Data Início Vigência"
              value={dtFimVig}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
